import { Alert, Box } from '@mui/material';
import Loading from '@components/shared/Loading';
import { Optimization } from './Optimization';
import { useCurrentCampaign, useCurrentReports } from '../../hooks';
import { useCurrentReport } from '@features/campaigns/subdomains/visitation/hooks/useReports';
import { SalesDataRefreshed } from '../SalesDataRefreshed';

export const OptimizationContainer = () => {
  const { campaign, isFetching } = useCurrentCampaign();
  const { reports, loading } = useCurrentReports();
  const {
    report: currentReport,
    salesReport,
    subdimensions,
  } = useCurrentReport();

  if (loading || isFetching) return <Loading />;

  if (!reports?.length || !currentReport || !campaign)
    return <Alert severity="error">No report found</Alert>;

  return (
    <>
      {salesReport ? (
        <Box paddingBottom="1rem">
          <SalesDataRefreshed reportDate={new Date(salesReport.reportDate)} />
        </Box>
      ) : null}
      <Optimization
        selectedReport={currentReport}
        latestSalesReport={salesReport}
        allReports={reports}
        campaignName={campaign.name}
        subdimensions={subdimensions}
      />
    </>
  );
};
